/* eslint-disable */

export const getTargetPairsConstants = {
    GET_TARGET_PAIRS_REQUEST: 'GET_TARGET_PAIRS_REQUEST',
    GET_TARGET_PAIRS_SUCCESS: 'GET_TARGET_PAIRS_SUCCESS',
    GET_TARGET_PAIRS_FAILURE: 'GET_TARGET_PAIRS_FAILURE',
};
